import { createReducer, on } from '@ngrx/store';
import * as invoicesActions from '../actions/invoices.actions';
import { InvoicesState } from '../../models/invoices.model';

export const initialInvoicesState: InvoicesState = {
    invoices: [],
    invoice: null,
    isLoading: false,
    error: null,
    totalItems: 0,
    totalPages: 0,
    selectedInvoiceId: null,
    selectedInvoice: null,
    filters: undefined,
    recalculateLoading: false,
    recalculateResult: null,
    recalculateError: null
};

export const invoicesReducer = createReducer(
    initialInvoicesState,

    on(invoicesActions.loadInvoices, (state, action) => ({
        ...state,
        isLoading: true,
        filters: action.filters,
        error: null
    })),
    on(invoicesActions.loadInvoicesSuccess, (state, action) => ({
        ...state,
        invoices: action.invoices.items,
        isLoading: false,
        error: null,
        totalItems: action.invoices.total_items,
        totalPages: action.invoices.total_pages
    })),
    on(invoicesActions.loadInvoicesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error
    })),
    on(invoicesActions.createInvoicesSuccess, (state, action) => ({
        ...state,
        invoices: action.invoices.items,
        totalItems: action.invoices.total_items,
        totalPages: action.invoices.total_pages,
        isLoading: false,
        error: null
    })),
    on(invoicesActions.createInvoicesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error
    })),
    on(invoicesActions.createInvoices, (state) => ({
        ...state,
        isLoading: true,
        error: null
    })),
    on(invoicesActions.loadInvoiceById, (state, action) => ({
        ...state,
        isLoading: true,
        selectedInvoiceId: action.id,
        error: null
    })),
    on(invoicesActions.loadInvoiceByIdSuccess, (state, action) => ({
        ...state,
        selectedInvoice: action.invoice,
        isLoading: false,
        error: null
    })),
    on(invoicesActions.loadInvoiceByIdFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error
    })),
    on(invoicesActions.updateServicePriceSuccess, (state, { invoice }) => ({
        ...state,
        selectedInvoice: invoice,
        loading: false,
        error: null
    })),
    on(invoicesActions.updateServicePrice, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(invoicesActions.updateServicePriceFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    on(invoicesActions.updateInvoiceReferenceSuccess, (state, { invoice }) => ({
        ...state,
        selectedInvoice: invoice,
        isLoading: false,
        error: null
    })),
    on(invoicesActions.updateInvoiceReferenceFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error
    })),
    on(invoicesActions.updateInvoiceReference, (state) => ({
        ...state,
        isLoading: true,
        error: null
    })),
    on(invoicesActions.regenerateInvoice, (state) => ({
        ...state,
        isLoading: true,
        error: null
    })),
    on(invoicesActions.regenerateInvoiceSuccess, (state, { invoice }) => ({
        ...state,
        selectedInvoice: invoice,
        isLoading: false,
        error: null
    })),
    on(invoicesActions.regenerateInvoiceFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error
    })),
    on(invoicesActions.recalculateInvoices, (state) => ({
        ...state,
        recalculateLoading: true,
        recalculateError: null
    })),
    on(invoicesActions.recalculateInvoicesSuccess, (state, { result }) => ({
        ...state,
        recalculateLoading: false,
        recalculateResult: result,
        recalculateError: null
    })),
    on(invoicesActions.recalculateInvoicesFailure, (state, { error }) => ({
        ...state,
        recalculateLoading: false,
        recalculateError: error
    })),
    on(invoicesActions.recalculateInvoice, (state) => ({
        ...state,
        recalculateLoading: true,
        recalculateError: null
    })),
    on(invoicesActions.recalculateInvoiceSuccess, (state, { result }) => ({
        ...state,
        recalculateLoading: false,
        recalculateResult: result,
        recalculateError: null
    })),
    on(invoicesActions.recalculateInvoiceFailure, (state, { error }) => ({
        ...state,
        recalculateLoading: false,
        recalculateError: error
    }))
);
